import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** ステータス */
enum ConnectionState {
  authorized = 'AUTHORIZED',
  deauthorized = 'DEAUTHORIZED',
  creating = 'CREATING',
  updating = 'UPDATING',
  deleting = 'DELETING',
}

const nameConfig = {
  authorized: new Map([
    [Locale.ja, '有効'],
    [Locale.en, 'Authorized'],
  ]),
  deauthorized: new Map([
    [Locale.ja, '無効'],
    [Locale.en, 'Deauthorized'],
  ]),
  creating: new Map([
    [Locale.ja, '作成中'],
    [Locale.en, 'Creating'],
  ]),
  updating: new Map([
    [Locale.ja, '更新中'],
    [Locale.en, 'Updating'],
  ]),
  deleting: new Map([
    [Locale.ja, '削除中'],
    [Locale.en, 'Deleting'],
  ]),
};

const toEnum = rawValueToEnum(ConnectionState, ConnectionState.deauthorized);
const toDisplay = enumToName(ConnectionState, nameConfig);
const toDisplayWithPrefix = enumToName(ConnectionState, nameConfig, { prefix: true });

export const connectionState = {
  enum: ConnectionState,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ConnectionState };
